// extracted by mini-css-extract-plugin
export var grid = "search-module--grid--fajBl";
export var img = "search-module--img--mPdUx";
export var leadMediaThumb = "search-module--leadMediaThumb--SaAvy";
export var root = "search-module--root--fTlX7";